import React, { useState, useEffect, useCallback } from "react";
import Axios from "axios";
import { connect } from "react-redux";
import Spinner from "../../../components/Spinner/Spinner";
import withErrorHandler from "../../../hoc/withErrorHandler/withErrorHandler";
import * as actions from "../../../store/actions/index";
import ShopCard from "./shopCard";
 
const AddShopCategory = (props) => {
  const [inputValues, setCategoryName] = useState({
    subCategoryName: "",
    editShopName: "",
  });

  const [subcategories, setSubcategories] = useState(null);

  const [oldCategory, setOldCategory] = useState({});
 
  useEffect(() => {
    props.onFetchShopSubCategories(); 
    // setTimeout(() => {
    //   setSubcategories(props.shop[0].subcategories);
    // }, 2000);
  }, []);

    useEffect(()=>{
        if(props.shop){
            setSubcategories(props.shop)
        }
    },[props.shop])
  const handleChange = useCallback((event) => { 
    const { name, value } = event.target;
    setCategoryName({ ...inputValues, [name]: value });
  });

  const handleSubmit = (e) => {
    e.preventDefault();
    let subCategoryName = inputValues.subCategoryName;
    let shopArray = props.shop;
    let subCategory = {
      name: subCategoryName,
    };
    props.onPostShopSubCategories(null, shopArray, subCategory);
  };

  const handleShopEdit = (e, id, oldName) => {
    const { name, value } = e.target;
    // console.log(name,value)
    setCategoryName({ ...inputValues, [name]: value });
    setOldCategory({ id: id, subCategoryName: oldName });
  };

  const handleEditSubmit = (e, id) => {
    e.preventDefault();
    let editedShop = inputValues.editShopName;
    let shopArray = props.shop;
    let subCategory = {
      id: id,
      name: editedShop,
    };
    let oldShopObj = oldCategory;
    props.onEditShopSubCategories(oldShopObj, shopArray, subCategory);
  };

  const handleDeleteSubCategories = (e, subCategory) => {
    e.preventDefault();
    props.onDeleteShopSubCategories(subCategory);
  };

  let diffCategories = subcategories;
  let shopTypes = 
    diffCategories &&
    diffCategories.map((shopTypes, index) => (
      <ShopCard
        key={index}
        id={shopTypes.id}
        subCategoryName={shopTypes.name}
        editShopName={inputValues.editShopName}
        handleChange={handleShopEdit}
        setSubcategories={() =>
          setCategoryName({
            ...inputValues,
            editShopName: shopTypes.name,
          })
        }
        handleEditSubmit={handleEditSubmit}
        handleDeleteSubCategories={handleDeleteSubCategories}
        shopBtnLoading={props.shopBtnLoading}
        deleteBtnLoading={props.deleteBtnLoading}
      />
    ));

  if (props.loading) {
    return <Spinner />;
  }
  return (
    <div className="container mt-2">
      <h3 className="text-center">Shop Management</h3>
      <form>
        <div className="row">
          <div className="col-md-3 m-1">
            <input
              name="subCategoryName"
              type="text"
              className="form-control"
              placeholder="Enter Sub category Name"
              onChange={handleChange}
              value={inputValues.subCategoryName}
            />
          </div>

          <div className="col m-1">
            <button
              type="submit"
              className="btn btn-info "
              onClick={handleSubmit}
              disabled={props.shopBtnLoading}
            >
              {props.shopBtnLoading ? "Adding" : "Add"}
            </button>
          </div>
        </div>
      </form>
      <hr />
      <div className="row mt-2">{shopTypes}</div>
    </div>
  );
};

const mapStateToProps = (state) => {
  return {
    shop: state.shop.shopSubCategories,
    loading: state.shop.loading,
    shopBtnLoading: state.shop.shopBtnLoading,
    deleteBtnLoading: state.shop.deleteBtnLoading,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    onPostShopSubCategories: (oldCategory, shopArray, subCategory) =>
      dispatch(
        actions.onPostShopSubCategories(oldCategory, shopArray, subCategory)
      ),
    onEditShopSubCategories: (oldCategory, shopArray, subCategory) =>
      dispatch(
        actions.onEditShopSubCategories(oldCategory, shopArray, subCategory)
      ),
    onFetchShopSubCategories: () =>
      dispatch(actions.onFetchShopSubCategories()),
    onDeleteShopSubCategories: (id) =>
      dispatch(actions.onDeleteShopSubCategories(id)),
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withErrorHandler(AddShopCategory, Axios));
